export default class CsvExporter {
  header (columns) {
    let result = '"sep=,"\r\n'
    result += this.line(columns)

    return result
  }  

  value (value) {  
    return "\"" + value.replace(/"/g, '""') + "\""
  }

  line (values) {
    return values.map(this.value).join(',') + '\r\n'
  }

  export (columns, data) {     
    let result = this.header(columns)

    data.forEach((item) => {
      let values = columns.map((column) => {
        return item.values[column] ? item.values[column] : ''
      })

      result += this.line(values)
    })

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/report/exporters/CsvExporter.js